import { useNotetakerMarketEligibility } from './useNotetakerMarketEligibility'

/** Activation / onboarding surfaces — visible to the market-eligible population, including entitled users. */
export const useNotetakerGrowthUiVisible = () => {
  const { isEligible, isLoading } = useNotetakerMarketEligibility()

  return { isVisible: isEligible, isLoading }
}
